import { EDIT_REFERRAL_DATA, SET_DATA_FOR_REFERRAL_TABLE, CLEAN_UP_REFERRAL_DATA, SET_IS_REFERRAL_SENT } from './types'

const initialState = {
  data: { effort_level: null, grade: null },
  dataForTable: {},
  isReferred: {},
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_IS_REFERRAL_SENT:
      return {
        ...state,
        isReferred: action.payload,
      }
    case EDIT_REFERRAL_DATA:
      const { name, value } = action.payload
      return {
        ...state,
        data: { ...state.data, [name]: value },
      }
    case CLEAN_UP_REFERRAL_DATA:
      return {
        ...state,
        data: {},
        isReferred: {},
      }

    case SET_DATA_FOR_REFERRAL_TABLE:
      return {
        ...state,
        dataForTable: action.payload,
      }

    default:
      return state
  }
}
